import { render, staticRenderFns } from "./imgD.vue?vue&type=template&id=d40d94b6"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d40d94b6')) {
      api.createRecord('d40d94b6', component.options)
    } else {
      api.reload('d40d94b6', component.options)
    }
    module.hot.accept("./imgD.vue?vue&type=template&id=d40d94b6", function () {
      api.rerender('d40d94b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/staffCardPlaceholders/imgD.vue"
export default component.exports